import { z } from 'zod';
import { ModoPermissaoSchema } from './painel';

/**
 * O `PermissionUpdate` do Agent SDK, em zod de verdade.
 *
 * Antes as sugestões viajavam como `record` opaco e a tela não sabia desenhar
 * "sempre permitir `Bash(npm test:*)`". Tipado, o painel mostra a regra e o
 * daemon devolve exatamente o que o SDK mandou — que é o que a doc dele pede
 * quando a pessoa marca "lembrar nesta sessão".
 *
 * Espelha o sdk.d.ts do pacote instalado; o teste de tipo no daemon
 * (`decisao.spec.ts`, Fase 5) é quem grita quando a Anthropic mudar o contrato.
 */
export const DestinoDePermissaoSchema = z.enum([
  'userSettings',
  'projectSettings',
  'localSettings',
  'session',
  'cliArg',
]);
export type DestinoDePermissao = z.infer<typeof DestinoDePermissaoSchema>;

export const RegraDePermissaoSchema = z.object({
  toolName: z.string().min(1).max(200),
  ruleContent: z.string().max(2_000).optional(),
});
export type RegraDePermissao = z.infer<typeof RegraDePermissaoSchema>;

const ComRegras = z.object({
  rules: z.array(RegraDePermissaoSchema).max(20),
  behavior: z.enum(['allow', 'deny', 'ask']),
  destination: DestinoDePermissaoSchema,
});

export const AtualizacaoDePermissaoSchema = z.discriminatedUnion('type', [
  ComRegras.extend({ type: z.literal('addRules') }),
  ComRegras.extend({ type: z.literal('replaceRules') }),
  ComRegras.extend({ type: z.literal('removeRules') }),
  z.object({
    type: z.literal('setMode'),
    mode: ModoPermissaoSchema,
    destination: DestinoDePermissaoSchema,
  }),
  z.object({
    type: z.literal('addDirectories'),
    directories: z.array(z.string().max(500)).max(20),
    destination: DestinoDePermissaoSchema,
  }),
  z.object({
    type: z.literal('removeDirectories'),
    directories: z.array(z.string().max(500)).max(20),
    destination: DestinoDePermissaoSchema,
  }),
]);
export type AtualizacaoDePermissao = z.infer<typeof AtualizacaoDePermissaoSchema>;

/**
 * O tipo do pedido decide o cartão: permissão comum, pergunta com opções,
 * plano para aprovar. `PROPOSTA` (ProposeGoal/ProposeSkills) e `ELICITACAO`
 * (MCP) já nascem no vocabulário para não exigir bump quando chegarem.
 */
export const TipoPedidoSchema = z.enum([
  'FERRAMENTA',
  'PERGUNTA',
  'PLANO',
  'PROPOSTA',
  'ELICITACAO',
]);
export type TipoPedido = z.infer<typeof TipoPedidoSchema>;
